module.exports = __webpack_public_path__ + "aa750996dd58f10d12b747ef0e303053.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/screenprint-tshirt-white-design-small.png
// module id = 810
// module chunks = 0